import { VALUE_NOT_TRUE } from 'constants/errors';
import { BaseCustomValidator } from '../types';

const requireTrueBaseValidator: BaseCustomValidator<boolean> = (validateModel, validate) => (
  value,
  options,
  attribute,
  attributes
) => {
  if (value === true) { return null; }
  if (options.message) { return options.message; }
  return VALUE_NOT_TRUE;
};

export default requireTrueBaseValidator;
